import { defineMessages } from 'react-intl';

const messages = defineMessages({
  subtitle_sws: {
    id: '+vPg2s',
    defaultMessage:
      'Get all the benefits of QRadar EDR without the need to invest in infrastructure.',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  getContactUs: {
    id: 'hZOGLS',
    defaultMessage: 'Contact Us',
  },
  estimatedMondthlyCosts: {
    id: '9NxZjj',
    defaultMessage: 'Estimated Monthly Cost',
  },
  edr_saas: {
    id: '/kAdXq',
    defaultMessage: 'EDR SaaS',
  },
  maximum_solution: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  inline_sws: {
    id: 'CI1KvW',
    defaultMessage: 'Software subscription information',
  },
  subheadline_sws: {
    id: 'ZKwMlW',
    defaultMessage: 'EDR (Software)',
  },
  contactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  saas_bullet_one: {
    id: 'mQxRPU',
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
  },
  welcomeMsg1: {
    id: 'zmuOOj',
    defaultMessage:
      'How many client devices does your organization need to protect?',
  },
  close: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  triggertextWorkstations: {
    id: 'f6fmVH',
    defaultMessage: 'Number of client devices',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  estimatedYearlyCosts: {
    id: 'EocqPl',
    defaultMessage: 'Estimated Annual Cost',
  },
  tooltipWorkStations: {
    id: 'u4Nj4t',
    defaultMessage:
      'A Client Device is a single user computing device or special purpose sensor or telemetry device that requests the execution of or receives for execution a set of commands, procedures, or applications from or provides data to another computer system that is typically referred to as a server or is otherwise managed by the server.',
  },
  getQuoteButton: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  asteriskPrice: {
    id: 'AHNom6',
    defaultMessage: 'Prices shown do not include tax.',
  },
  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
  edr_software: {
    id: 'zSuh9z',
    defaultMessage: 'EDR Software',
  },
  tooltipBreachInfo: {
    id: 'Vh0POG',
    defaultMessage:
      'Get all the benefits of QRadar EDR and let the experts at IBM MSS manage, detect, and respond to security alerts for you.',
  },
  scopingQuestions: {
    id: 'SLvWs/',
    defaultMessage: 'Size your solution',
  },
  ty_insights: {
    id: '1vMskb',
    defaultMessage: 'Get the right insights for your needs',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  offerings: {
    id: '6IX9se',
    defaultMessage: 'Offering Selected: ',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
});

export default messages;
